// extracted by mini-css-extract-plugin
export default {"heading":"heading-CuIgF","sectionHeading":"sectionHeading-S5iEJ","radioBar":"radioBar-rCbBA","sectionMain":"sectionMain-P0fmH"};